import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'cagov-footer',
    templateUrl: './cagov-footer.component.html',
    styleUrls: ['./cagov-footer.component.scss'],
    standalone: false,
})
export class CagovFooterComponent {
    readonly year = new Date().getFullYear();

    @Input() title: string = '';
    @Input() version: string = '0.0.0';
    @Output() onBackToTop: EventEmitter<MouseEvent> = new EventEmitter();

    constructor(private router: Router) {}

    /**
     * Gets the current component route for same page navigations.
     */
    get currentRoute() {
        return this.router.url;
    }

    /**
     * Handles a click of the 'Back to Top' link by delegating to the app component logic.
     * @param event The click event.
     */
    backToTop(event: MouseEvent): void {
        this.onBackToTop.emit(event);
    }
}
